import { render, staticRenderFns } from "./HeaderSubmenus.vue?vue&type=template&id=105aef4a&"
import script from "./HeaderSubmenus.vue?vue&type=script&lang=js&"
export * from "./HeaderSubmenus.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSubmenus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports